import { ActionIcon, Button, CopyButton, TextInput, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy, IconPlus } from '@tabler/icons';
import { FC, useContext, useMemo } from 'react';
import { RoutingS } from '../../../../Service/RoutingS';
import { WindowContext } from '../../../../Service/Context/WindowContext';
import { ThemeText } from '../../../../Atoms/ThemeText';
import { CalDavS } from '../../../../Service/CalDavS';
import { CalendarSubscriptionEntityType } from '../../../../Types/CalDavT';

interface Props {
  calendarSubscriptionId: string;
  entityType: CalendarSubscriptionEntityType;
  label: string;
}

const Subscription: FC<Props> = ({ calendarSubscriptionId, entityType, label }) => {
  const { sm } = useContext(WindowContext);
  const url = useMemo(
    () => CalDavS.getCalendarSubscriptionUrl(calendarSubscriptionId, entityType),
    [calendarSubscriptionId, entityType],
  );
  const webcalUrl = url.replace(/^https:/, 'webcal:');

  return (
    <>
      <TextInput
        readOnly
        variant="filled"
        label={
          <ThemeText size="sm" weight="bolder">
            {label}
          </ThemeText>
        }
        description="Kopiere die passende URL und füge sie in Deiner Kalender-App als Abo hinzu. bookitup hält die Einträge automatisch aktuell."
        value={url}
        sx={{ flex: 1, minWidth: sm ? '100%' : 0 }}
        styles={{
          input: {
            cursor: 'text',
            fontFamily: 'monospace',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        }}
        rightSectionWidth={42}
        rightSection={
          <CopyButton value={url} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Kopiert' : 'Kalender-URL kopieren'} withArrow>
                <ActionIcon color={copied ? 'teal' : 'gray'} onClick={copy}>
                  {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        }
      />
      {sm && (
        <Button
          compact
          variant="subtle"
          leftIcon={<IconPlus size={16} />}
          onClick={() => RoutingS.openInNewTab(webcalUrl)}
          sx={{ width: 200 }}
        >
          Kalender abonnieren
        </Button>
      )}
    </>
  );
};

export { Subscription };
export default Subscription;
